var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"my-5"},[_c('v-col',[_c('h1',{staticClass:"d-flex flex-column flex-md-row justify-center text-center text-uppercase font-weight-regular"},[_c('v-icon',{staticClass:"mr-md-5",attrs:{"x-large":"","color":"primary"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._v(" "+_vm._s(_vm.title)+" ")],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }